import React from "react";
import { Form } from "react-final-form";
import cx from "classnames";

import Tabs from "../Tabs";
import { FormNewPatient, ExistingPatient } from "../CalendarScheduleDoctor";
import { useLocalization } from "../../../context/LocalizeContextProvider";
import usePatientReservationValidation from "../../../utils/validation/usePatientReservationValidation";

export default function TabsPatientSelection({
  label,
  labelClass,
  selectedExistingPatient,
  setSelectedExistingPatient,
  handleSubmitExisting,
  dataFormNew,
  handleSubmitNew,
  handleChangeForm,
  existingPatientActions,
  newPatientActions,
  showFormForNewPatient = false,
  onTabChange, // New prop to track tab changes
}) {
  const localize = useLocalization();
  const validate = usePatientReservationValidation();

  return (
    <div className="form-group">
      {label && (
        <label className={cx(labelClass, "mb-3")}>
          <strong>{label}</strong>
        </label>
      )}
      <Tabs
        onChange={onTabChange}
        items={[
          {
            label: localize.getText("existingPatient"),
            key: "1",
            children: (
              <div className="d-flex flex-column gap-4">
                <ExistingPatient
                  selectedExistingPatient={selectedExistingPatient}
                  setSelectedExistingPatient={setSelectedExistingPatient}
                />
                {existingPatientActions}
              </div>
            ),
          },
          {
            label: localize.getText("newPatient"),
            key: "2",
            children: showFormForNewPatient ? (
              <Form
                initialValues={{ ...dataFormNew }}
                validate={validate}
                onSubmit={handleSubmitNew}
              >
                {({ handleSubmit, values, valid }) => (
                  <form
                    className="row row-gap-4"
                    style={{ rowGap: 12 }}
                    onSubmit={handleSubmit}
                  >
                    <FormNewPatient
                      value={dataFormNew}
                      handleChangeForm={handleChangeForm}
                    />
                    {newPatientActions}
                  </form>
                )}
              </Form>
            ) : (
              <div className="row row-gap-4" style={{ rowGap: 12 }}>
                <FormNewPatient
                  value={dataFormNew}
                  handleChangeForm={handleChangeForm}
                />
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}
